import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEOHead from '../components/seo/SEOHead';
import InternalLinks from '../components/seo/InternalLinks';

export default function NotFound() {
  return (
    <div className="min-h-screen" data-testid="not-found-page">
      <SEOHead
        title="Page Not Found | Alden Technologies"
        description="The page you are looking for does not exist. Explore our mineral water bottling plants, water filling machines and RO plants."
        path="/404"
      />
      <section className="py-24 bg-gradient-to-br from-alden-green to-alden-green-light text-white text-center">
        <div className="container mx-auto px-4">
          <div className="text-8xl font-bold mb-4">404</div>
          <h1 className="text-4xl sm:text-5xl font-bold mb-6">Page Not Found</h1>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            The page you are looking for has been moved or does not exist. Explore our mineral water bottling plant solutions below.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" data-testid="not-found-home-link">
              <Button className="bg-white text-alden-green hover:bg-gray-100 py-6 px-8 text-lg font-semibold">
                <Home className="mr-2" /> Go to Homepage
              </Button>
            </Link>
            <Link to="/products">
              <Button className="bg-alden-navy hover:bg-alden-navy-light text-white py-6 px-8 text-lg font-semibold">
                View Products <ArrowRight className="ml-2" />
              </Button>
            </Link>
            <a href="tel:+919351292512">
              <Button className="bg-white/10 border-2 border-white text-white hover:bg-white/20 py-6 px-8 text-lg font-semibold">
                <Phone className="mr-2" /> Call: +91-9351292512
              </Button>
            </a>
          </div>
        </div>
      </section>
      <InternalLinks />
    </div>
  );
}
